/**
 * 첨부 파일명 중복 판정.
 *
 * 백엔드는 저장·발급 경로에서 이미 동명 파일을 거절하지만(449/448), 청크 업로드는 수 분이
 * 걸리므로 **파일을 고르는 순간** 막아야 사용자가 기다린 뒤 거절당하지 않는다.
 *
 * 판정 기준은 백엔드와 같아야 한다 — 백엔드는 NFC 로 정규화해 비교하고
 * (`database/models/resource.py:243` `unicodedata.normalize("NFC", …)`),
 * macOS 는 파일명을 NFD 로 준다. 여기서 정규화를 빼면 한글 파일명에서 프론트는 통과시키고
 * 서버가 거절하는 갈림이 생긴다.
 */

export const normalizeFilename = (name) => (typeof name === 'string' ? name.normalize('NFC') : '')

/**
 * @param {Array<{filename?: string}>} fileInfos 이미 이 필드에 붙어 있는 파일들
 * @param {string} filename 새로 고른 파일명
 * @returns {boolean}
 */
export const isDuplicateFilename = (fileInfos, filename) => {
  const target = normalizeFilename(filename)
  // 이름이 비면 판정하지 않는다 — 이름 없는 파일끼리 서로를 막아 첨부가 불가능해지는 것을 피한다
  if (target === '') return false
  if (!Array.isArray(fileInfos)) return false

  return fileInfos.some((info) => normalizeFilename(info?.filename) === target)
}
